import React from "react";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import { useGame } from "context/gameContext";

import SkeletonLoader from "components/skeletonLoader";

import { useTranslation } from "react-i18next";
import { classNames } from "utils/utils";
import Info from "components/info";
import {
  CloudIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

import {
  Md2EmoticonDeadOutline,
  Md2ClockTimeFourOutline,
  Md2CheckCircleOutline,
} from "react-icons-ng/md2";
import { ClockIcon } from "@heroicons/react/24/solid";
import Clock from "components/clock";
import LeaderboardInfo from "components/leaderboardInfo";

const RoundStatus = () => {
  const { t } = useTranslation();

  const {
    state: { predictionLeagueRoundData, userRoundData, currentRound },
  } = useRound();
  const {
    state: { leagueUserData, allRounds, nextRoundId, leagueInfo },
  } = useLeague();
  const {
    state: { theme },
  } = useGame();
  let IconComponent = () => null;
  const exitRoundPos = allRounds.find(
    (x) => x.id === leagueUserData?.exitRound
  );
  let exitRound =
    t("tournament.roundtab.round") + " " + (exitRoundPos?.pos + 1);

  let nextRoundPos = allRounds.find((x) => x.id === nextRoundId);
  let nextRound = nextRoundPos?.pos + 1;

  const drawUsed = leagueUserData?.drawCount > 0;

  let title,
    subtitle = "";

  let nextDeadline = new Date(nextRoundPos?.deadline?.seconds * 1000);

  let roundStarted = nextRoundPos?.deadline?.seconds * 1000 > new Date();
  let status;

  if (leagueUserData?.gameOver) {
    status = "danger";
    title = t("tournament.lmsHelp.gameOver.title");
    subtitle = t("tournament.lmsHelp.gameOver.subtitle", {
      round: exitRound,
    });
  } else if (leagueInfo?.settled) {
    status = "success";
    title = t("tournament.lmsHelp.won.title");
    subtitle = t("tournament.lmsHelp.won.subtitle");
  } else if (nextRoundPos?.pos == 0 && !userRoundData?.placedPrediction) {
    status = "warning";
    title = t("tournament.lmsHelp.first.title");

    subtitle = t("tournament.lmsHelp.first.subtitle", {
      round: nextRound,
      deadline: nextDeadline,
      formatParams: {
        deadline: {
          weekday: "long",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        },
      },
    });

    IconComponent = (
      <span className=" text-yellow-500 h-fit">
        <Clock />
      </span>
    );
  } else if (userRoundData?.placedPrediction && !currentRound?.settled) {
    status = "success";
    IconComponent = (
      <span className=" text-customGreen">
        <Md2CheckCircleOutline className="h-6 w-6" />
      </span>
    );

    title = t("tournament.lmsHelp.ready.title");
    subtitle = t("tournament.lmsHelp.ready.subtitle", {
      deadline: nextDeadline,
      formatParams: {
        deadline: {
          weekday: "long",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        },
      },
    });
  } else if (drawUsed) {
    title = t("tournament.lmsHelp.nextDraw.title", {
      round: nextRound,
      deadline: nextDeadline,
      formatParams: {
        deadline: {
          weekday: "long",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        },
      },
    });
    subtitle = t("tournament.lmsHelp.nextDraw.subtitle");
  } else {
    title = t("tournament.lmsHelp.nextWon.title", {
      round: nextRound,
    });
    subtitle = t("tournament.lmsHelp.nextWon.subtitle", {
      deadline: nextDeadline,
      formatParams: {
        deadline: {
          weekday: "long",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        },
      },
    });
  }

  return leagueUserData?.gameOver ||
    leagueInfo?.settled ||
    (currentRound?.id === nextRoundId && roundStarted) ? (
    <div className="flex mb-2 items-center justify-center w-full space-x-2">
      <LeaderboardInfo
        //icon={IconComponent}
        title={title}
        subtitle={subtitle}
        type={status}
      />
      {/* <Info count={""} label={title} icon={IconComponent} /> */}
    </div>
  ) : (
    ""
  );
};

export default RoundStatus;
